import styled from 'styled-components';

interface FieldErrorProps {
  hidden?: boolean;
}

export const FieldError = styled.div.attrs({
  role: 'alert',
  className: 'error-message',
})<FieldErrorProps>`
  color: ${({ theme }) => theme.global.error_color};
  top: ${({ theme }) => theme.forms.field_height}px;
  font-size: 12px;

  ${({ hidden }) =>
    hidden &&
    `
    display: none;
  `}
`;
